// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.allig-text-link[data-v-51d5f5cd] {\r\n  color: #388E3C;\n}\n.allig-text-link[data-v-51d5f5cd]:hover {\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n  color: #4CAF50;\n}\r\n", ""]);
// Exports
module.exports = exports;
